/**
 * Envoltorio estándar de respuesta de los repositorios.
 */
export class ResponseValueObject<T> {
  constructor(
    public readonly success: boolean,
    public readonly data: T,
    public readonly message?: string
  ) {}
}
